<template>
    <b-modal
      :key="id"
      v-model="shown"
      size="lg"
      centered
      no-close-on-esc
      no-close-on-backdrop
      class="EditorModal">
      <div slot="modal-header" class="px-3">
        <b-form-group label="Segment Name">
          <b-form-input
            id="input-large"
            size="lg"
            v-model="name"
            type="text"
            placeholder="Segment Name"
            :state="showErrors && !name ? false : null"
            required />
        </b-form-group>
     
      </div>

      <div class="px-3">
        <filter-rules
          :filters="filters"
          :logic="logic"
          :collection="collection_name"
          :database="database_name"
          :data_type="data_type"
          :file="file"
          :show-errors="showErrors"
          :working="isSaving"
          @patch="onFilterRulesPatch"
          />
      </div>

      <div slot="modal-footer" style="width: 100%">
        <div class="text-right">
          <b-button @click="onClose" :disabled="isSaving" variant="outline" class="px-3" size="md">
            Cancel
          </b-button>
          <b-button @click="onSave" :disabled="isSaving" variant="success" class="px-3" size="md">
            <i class="fa fa-spinner fa-spin mr-2" v-if="isSaving"></i>
            Save
          </b-button>
        </div>
      </div>
    </b-modal>
</template>

<script>
	import FilterRules from '../FilterRules';
  import {saveSegment} from '../../store/segments';
	
  

  export default {
    name: 'SegmentEditor',
    components: { FilterRules },

    props: {
      id: String,
      collection_name: String,
      database_name: String,
      data_type: String,
      file: String,
      defaultName: {
        type: String,
        default: ''
      }
    },

    data() {
      // const collections = this.$store.state.files.collections
      const segment = this.$store.state.segments.segmentList.find(({id}) => id === this.id);
      const defaults = {name: this.defaultName, filters: []};
      const {name, filters, logic, collection} = segment || defaults;
      // const collection = this.collection;
      return {
        
        shown: true,
        isSaving: false,

        complete: true,
        showErrors: false,
        collection,
        // collection_names: collections,
        // collections,
      
				name,
				filters,
				logic,
			};
    },
    // created() {
		
		// 	this.$root.$on('selected-collection', (val) => {
    //     this.collection = val;
    //     console.log("EditorCollection",this.collection);
		// 	})

		// },
    methods: {
      onClose(changed=false) {
        this.shown = false;
        this.$emit('close', changed);
      },

      onFilterRulesPatch(patch) {
        this.complete = patch.complete;
        // this.collection = (this.data_type === 'file') ? patch.file : patch.collection || this.collection;
        this.collection = patch.collection || this.collection;
        this.database = patch.database || this.database;
      	this.filters = patch.filters || this.filters;
      	this.logic = patch.logic || this.logic;
      },

      onSave() {
        this.collection = this.file; // (this.data_type === 'file') ? this.file : this.collection;
        const {id, name, filters, logic, collection, database, complete} = this;
    

        if (!name || !complete) {
          this.showErrors = true;
          return;
        }

        this.isSaving = true;
        this.$store.dispatch(saveSegment({id, name, filters, collection, database, logic}))
          .then(() => {
            this.onClose(true);
          })
          .catch(console.log);
      }
    }
  };
</script>


<style>
  @media (min-width: 992px) {
    .EditorModal .modal-lg {
      max-width: 900px;
    }
  }
</style>
